/**
 * @override King Living: BaseIconSetFragment with CF-054 explainerBlocksCollection.
 * Requests explainerBlocksCollection so icons + explainer blocks render in IconSet.
 */

import gql from 'graphql-tag';

import {BaseIconFragment} from '@amblique/contentful/app/contentful/fragments/icon/base-icon.fragment';

export const BaseIconSetFragment = gql`
  ${BaseIconFragment}

  fragment BaseIconSetFragment on IconSet {
    __typename
    sys {
      id
    }
    title
    textColour
    backgroundColour
    jumpLink
    jumpLinkMarginTop
    maxItemsPerRowDesktop
    explainerBlocksCollection {
      items {
        __typename
        ... on Icon {
          ...BaseIconFragment
        }
      }
    }
  }
`;
